import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoggedOutGuard implements CanActivate {
  private static allowAccess = false;

  constructor(private readonly router: Router) {}

  public static setAllowAccess(allow: boolean): void {
    LoggedOutGuard.allowAccess = allow;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (LoggedOutGuard.allowAccess) {
      return true;
    }

    // If not allowed, redirect to discover page
    this.router.navigate(['/discover']);
    return false;
  }
}
